
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bccjcnbdakyzqsagnwya.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjY2pjbmJkYWt5enFzYWdud3lhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5ODgyMzAsImV4cCI6MjA2MDU2NDIzMH0.LAulDsWDh5Pg6YqqhWfWeA1Fz9XAnpjwzi2TyunOauI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: window.localStorage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'  // Use PKCE flow for better security
  }
});
